const theme = {
  bgColor: '#121217',
  mainColor: '#e5b975',
};
export default theme;
